import { Grid, Typography } from '@mui/material';
import React from 'react';
import { useFormContext } from 'react-hook-form';
import AddressAutocomplete from '../../../../shared/AddressAutocomplete';
import FormAutocomplete from '../../../../shared/FormAutocomplete';
import FormTextField from '../../../../shared/FormTextField';
import { Address } from '../../../../types/generic';

const stateOptions = [
    { value: 'NSW', label: 'NSW' },
    { value: 'QLD', label: 'QLD' },
    { value: 'VIC', label: 'VIC' },
    { value: 'SA', label: 'SA' },
    { value: 'WA', label: 'WA' },
    { value: 'NT', label: 'NT' },
    { value: 'TAS', label: 'TAS' },
    { value: 'ACT', label: 'ACT' },
];

const countryOptions = [{ value: 'AU', label: 'Australia' }];

const ItineraryAddressFields = ({
    name,
    autocompletePlaceholder,
    title,
}: {
    name: string;
    autocompletePlaceholder: string;
    title?: string;
}) => {
    const { setValue, control } = useFormContext();

    const handleAddress = (address: Address) => {
        setValue(`${name}.streetAddress`, address.streetAddress, {
            shouldDirty: true,
            shouldValidate: true,
        });
        setValue(`${name}.suburb`, address.suburb, {
            shouldDirty: true,
            shouldValidate: true,
        });
        setValue(`${name}.state`, address.state, {
            shouldDirty: true,
            shouldValidate: true,
        });
        setValue(`${name}.postcode`, address.postcode, {
            shouldDirty: true,
            shouldValidate: true,
        });
        setValue(`${name}.countryCode`, address.country, {
            shouldDirty: true,
            shouldValidate: true,
        });
    };

    return (
        <>
            {title ? (
                <Grid item xs={12}>
                    <Typography variant='body3' sx={{ fontWeight: 600 }}>
                        {title}
                    </Typography>
                </Grid>
            ) : null}

            <Grid container item spacing={2}>
                <Grid item xs={12} sm={6}>
                    {' '}
                    <AddressAutocomplete
                        height='4px'
                        onChange={handleAddress}
                        placeholder={autocompletePlaceholder}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FormTextField
                        name={`${name}.streetAddress`}
                        control={control}
                        label='Street address'
                        placeholder='100 Main St'
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormTextField
                        name={`${name}.suburb`}
                        control={control}
                        label='Suburb'
                        placeholder='Sydney'
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormAutocomplete
                        name={`${name}.state`}
                        control={control}
                        label='State'
                        options={stateOptions}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormTextField
                        name={`${name}.postcode`}
                        control={control}
                        label='Postcode'
                        placeholder='2000'
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormAutocomplete
                        name={`${name}.countryCode`}
                        control={control}
                        label='Country'
                        options={countryOptions}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default ItineraryAddressFields;
